// @vue/component
export default {
  name: 'modal-what-happens',

  props: ['plan_type', 'start_date', 'launch_date'],

  methods: {
    showModal() {
      this.$refs.whatHappens.show();
    },
    hideModal() {
      this.$refs.whatHappens.hide();
    },
  },
};
